<template>
		<main id='lucky'>
			<mt-header title="幸运大转盘"  fixed>
				  <a href="javascript:void(0)" slot="left" @click="returnBack">
				    <mt-button icon="back" class="font-Yahei"></mt-button>
				  </a>
			</mt-header>
			<div class="zpwrap">
			<div class='lucky-rule' @click='showRule=true'>活动规则</div>
			<div class='lucky-title'>
				<img src="../../../static/images/title.png" />
				<p v-cloak><span class='lucky-sdate'>{{startDate}}</span>－<span class='lucky-edate'>{{endDate}}</span></p>
			</div>
			<div class='lucky-turnplate'>
				<canvas class="item" id="wheelcanvas" width="422px" height="422px"></canvas>
				<img v-if='isLogin' class="pointer" src="../../../static/images/pointer-begin.png" @click='btnStartTurn'/>
				<img v-else class="pointer" src="../../../static/images/pointer-reg.png" @click="toReg"/>
			</div> 
			<div class='lucky-winners'>
				<div class="lucky_box">
				<ul class="lucky_list" :class="{luckyTop:animate}">
					<li v-for='item,index in winners' :key='item.uid+index' >
						{{replaceStar(item.uid)}} 抽中了{{item.yamount}}元优惠券
					</li>
				</ul>
				</div>
			</div>
			<div class="lucky-myprize" v-show='username' @click='routeTo("ticket")'>
				<img src='../../../static/images/myprize.png' />
			</div>
			<div class='lucky-QRcode'>
				<img src="../../../static/images/QRcode.png" />
				<p>关注微信公众号，进入商城</p>
				<p>购买任何商品均可使用优惠券</p>
			</div>
		<aside v-show='showRule'>
			<div class='lucky-rule-page'>
				<div class='lucky-rule-title'><img src="../../../static/images/rule.png"/></div>
				<div class="lucky-rule-list">
					<p>1.手机号可免费注册商城账号，登录盈卡商城即可参与抽奖;</p>
					<p>2.同一用户仅有1次抽奖机会，同一终端设备、同一手机号均视为同一用户，奖品随机抽中，数量有限，送完即止;</p>
					<p>3.该优惠券针对盈卡商城所有商品均有效，下单支付时即可使用优惠券，优惠券使用后概不退还，使用细则见优惠券说明;</p>
					<p>4.中奖优惠券有效期为7天，从获奖之日开始计算，过期失效，请尽快使用;</p>
					<p>5.活动过程中，不允许使用任何工具作弊，如出现异常、违规行为，将撤销中奖奖品，必要时追究法律责任。</p>
				</div>
				<div class='lucky-prompt-close' @click='showRule=false'><img src="../../../static/images/close.png"/></div>
			</div>
		</aside>
		<aside v-show='errcode'>
			<div class="lucky-prompt">
				<p v-if='errcode==200'>恭喜您抽中{{parseInt(amount)}}<span id="litticval1" v-show="litamount!=-1">.{{litamount}}</span>元优惠券！</p>
				<!--<p v-else-if='errcode==206'>您的抽奖机会已经用完啦<br/>谢谢参与!</p>-->
				<p v-else-if='errcode==201' id="pallsale">今日的奖品已全部发放完啦<br/>明日再来吧!</p>
				<p v-else-if='errcode==202||errcode==207' id="pallsale">您的抽奖机会已经用完啦<br/>谢谢参与!</p>
				<p v-else-if='errcode==205'>当前抽奖的人数过多<br/>请稍等一会再抽奖</p>
				<p v-else-if='errcode==404'>奖品已全部发放完啦<br/>谢谢参与!</p>
				<p v-else-if='errcode==401'>活动还未开始哦！</p>
				<p v-else-if='errcode==402'>活动结束啦，谢谢参与！</p>
				<div class='lucky-imgtitle'>
					<!--'+amount+'-->	
					<span v-if='errcode==200' class="ticketvalwrap">
					<img  :src="'../../../static/images/quan'+amount1+'.png'"/>
				    <span id="ticketval" v-show="amount==1?false:amount==2?false:amount==5?false:amount==10?false:amount==15?false:true">
				    	<span id="valwrap">
				    		<span>{{parseInt(amount)}}</span>
				    	    <span id="litticval" v-show="litamount!=-1">.{{litamount}}</span>
				    	</span>
				    </span>
				      <!--v-show="amount1!=1||amount1!=2||amount1!=5||amount1!=10||amount1!=15"-->
					</span>
					<img v-else-if='errcode==207||errcode==404' src="../../../static/images/complete.png"/>
					<img v-else-if='errcode==202||errcode==201' src="../../../static/images/box.png"/>
					<img v-else-if='errcode==205' src="../../../static/images/man.png"/>
					<img v-else-if='errcode==401||errcode==402' src="../../../static/images/box.png"/>
				</div>
				<p class='lucky-hint' v-show='errcode==200'>在个人中心查看优惠券</p>
				<a v-show='errcode && errcode!=200' @click='errcode=false'>确定</a><a v-show='errcode==200' @click='routeTo("ticket")'>去使用</a>
				<div class='lucky-prompt-close' @click='errcode=false'><img src="../../../static/images/close.png"/></div>
			</div>
		</aside>
		</div>
		</main>
</template>

<script type="text/ecmascript-6">
	import { Toast } from 'mint-ui';
	import {myfun} from '../../../static/js/awardRotate.js';
	export default {
		name: 'lucky',
		data() {
			return {
				username: localStorage.getItem('username'),
				showRule: false, //是否显示活动规则页
		        errcode: false, //抽奖返回结果
		        amount: 0, //中奖金额
		        amount1: 0, //图片下标
		        litamount:-1, //小数点后面的数
				startDate: false, //活动开始时间
				endDate: false, //活动结束时间
				winners:[],
				wTimer: false,
				isLogin: false, //是否登录
				//抽奖转盘参数
				prizes: [{
					url: '../../../static/images/prize01.png',
					amount: 1
				}, {
					url: '../../../static/images/prize02.png',
					amount: 10
				}, {
					url: '../../../static/images/prize03.png',
					amount: 5
				}, {
					url: '../../../static/images/prize04.png',
					amount: 15
				}, {
					url: '../../../static/images/prize05.png',
					amount: 10
				}, {
					url: '../../../static/images/prize06.png',
					amount: 15
				}, {
					url: '../../../static/images/prize07.png',
					amount: 2
				}, {
					url: '../../../static/images/prize08.png',
					amount: 5
				}],
				startAngle: 0.3927,
				outsideRadius:162,
		        textRadius: 120,
		        insideRadius: 30,          
		        loadNum: 0,
		        bRotate: false,
		        turnstop: true, //转盘是否已经停止
		        movableType:this.$route.query.movableType,//渠道号 1.移动商城   2.电话钱包网   3.微信公众号
		        cname:this.Act_Cname,//活动类名
		        md5sign:this.Act_md5sign,
		        animate: false
			}
		},
		created() {
			this.movableActive(0);
			this.getLuckyInfo();
			this.getWinnerList();
			this.$nextTick(() => {
				for(let i = 0; i < this.prizes.length; i++){
					this.loadImage(i, this.prizes[i].url, this.drawRouletteWheel)
				}
			});
			setInterval(this.startWinnersTimer, 3000);
			this.isUserLogin();
		},
		beforeDestroy(){
			clearInterval(this.startWinnersTimer);
		},
		methods: {
			returnBack(){
	       	 this.$router.push({path: '/'});
	        },
	        //活动统计
	        movableActive(userName){
	        	var signM=md5('movableType='+this.movableType+'&cname='+this.cname+'&'+this.md5sign);
	        	this.$http.post(this.URL_PREFIX+"/activity/movableActive",{movableType:this.movableType,cname:this.cname,sign:signM,uName:userName})
				  .then((res) =>{
				});
	        },
			isUserLogin(){
				this.$http.post(this.URL_PREFIX+"/user/isUserLogin.net",{phone:this.username})
				  .then((res) =>{
					if(res.data.code==200){
						this.isLogin = true;
					}
				})
			},
			toReg(){ //跳转到注册页
//				this.$router.push({path: "/Register",query:{redirect:"lucky",movableType:this.movableType}});
                this.$router.push({path: "/Register",query:this.$route.query});
			},
			routeTo(page){
				this.$router.push({path: page});
			},
			getWinnerList() { //获取中奖名单
				this.$http.post(this.URL_PREFIX+"/activity/findWinningInfo.net",{cname:this.cname})
				  .then((res) =>{
					this.winners =res.data.rows;
				});
				
			},
			startWinnersTimer() {
					this.animate = true;
					setTimeout(()=>{
	                   this.winners.push(this.winners[0]);
		               this.winners.shift();
		               this.animate = false;
	                },500);
			},
			replaceStar(phone) {
				return phone.substr(0,3) + '****' + phone.substr(7)
			},
			getLuckyInfo() { //获取活动信息
				this.$http.post(this.URL_PREFIX+"/activity/findMovable.net",{cname:this.cname})
				  .then((res) =>{
					if(res.data.code == 200){
						this.startDate = res.data.obj.startDate.replace(/[-]/g,".");
						this.endDate = res.data.obj.endDate.replace(/[-]/g,".");
					}
				})
			},
			btnStartTurn() { //开始抽奖
				if(this.turnstop==true){				
		    	    this.turnstop = false;
					this.rotateWait()
					this.getLuckDraw();
				}
			},
			getLuckDraw() { //调用抽奖接口
				var signMd=md5('cname='+this.cname+'&phone='+this.username+'&'+this.md5sign);
				this.$http.post(this.URL_PREFIX+"/activity/luckDraw.net",{cname:this.cname,phone:this.username,sign:signMd})
				  .then((res) =>{
					$('#wheelcanvas').stopRotate();
			  		switch(res.data.code){
			  			case 200:
			  				this.pointer(res.data.obj.yamount);
			  				this.movableActive(this.username);
				  			break;
				  	    case 201:  //总中奖次数日限
				  		case 205:  //当前抽奖的人数过多
				  		case 401:  //活动未开始
				  		case 402:  //活动已结束
				  		case 404:  //404  没有优惠劵信息
				  			this.errcode = res.data.code;
				  			this.turnstop = true;
				  			break;
				  		case 202:  //单IP中奖次数限制
				  		case 203:  //同号段抽奖次数限制
				  		case 204:  //同号段抽奖次数日限				  		
				  		case 206:  //超过限领张数
				  		case 207:  //单个人中奖次数日限
				  			this.errcode = 202;
				  			this.turnstop = true;
				  			break;
				  		default:
				  			Toast(res.data.msg); 
				  			this.turnstop = true;
			  		}
			  	});
			},
			pointer (value) {
				this.amount = value;
				if(value.indexOf('.')!=-1){
					var arr = value.split(".")
					this.litamount = arr[1];
				}else{
					this.litamount = -1;
				}             
				if(value==1||value==2||value==5||value==10||value==15){
					this.amount1 = value;
				}else{
					this.amount1 = "";
				}
				var index = 0
				for(var i = 0; i < this.prizes.length; i++){
					if(this.prizes[i].amount == value){
						index = i
						break;
					}
				}
		      this.bRotate = !this.bRotate
		      this.rotateFn(parseInt(i) + 1,value)
		    },
		    rotateWait() {
		    	let _this = this
		    	this.$nextTick(() => {
			        $('#wheelcanvas').stopRotate()
			         $('#wheelcanvas').rotate({
			          angle: 0,
			          animateTo: 10000000,
			          duration: 8000000,
			          callback: function () {
			          	_this.errcode = 205
			          }
			        })
		      	})
		    },
		    rotateFn(item,value) {
		      if(value==1||value==2||value==5||value==10||value==15){
		           var angles = item * (360 / this.prizes.length) - (360 / (this.prizes.length * 2));
		      }else{
		      	   var angles = item * (360 / this.prizes.length)-4;
		      }
//            var angles = item * (360 / this.prizes.length);
		      if (angles < 270) {
		        angles = 270 - angles - 25
		      } else {
		        angles = 360 - angles + 270 - 25
		      }
		      let _this = this
		      this.$nextTick(() => {
		        $('#wheelcanvas').stopRotate()
		         $('#wheelcanvas').rotate({
		          angle: 0,
		          animateTo: angles + 1800,
		          duration: 8000,
		          callback: function () {
		          	_this.errcode = 200
		          	_this.bRotate = !_this.bRotate
		          	_this.turnstop = true;
		          }
		        })
		      })
		    },
			loadImage(i,url,callback) {       
			    var img =new Image();
			    img.src = url
			    let _this = this
			    img.onload =function(){  
			        img.onload =null;  
					_this.loadNum ++
			        if(_this.loadNum == _this.prizes.length){
			        	callback(img);  
			        }
			    }  
			},  
			drawRouletteWheel() { //初始化转盘
				let canvas = document.getElementById('wheelcanvas')
				canvas.width = 2 * 422;
			    canvas.height = 2 * 422;
				if(canvas.getContext) {
					// 根据奖品个数计算圆周角度
					var arc = Math.PI / (this.prizes.length / 2)
					var ctx = canvas.getContext('2d')
					ctx.scale(2,2);/*先放大再缩小增加清晰度*/
					// 在给定矩形内清空一个矩形
					ctx.clearRect(0, 0, 422, 422)
					for(var i = 0; i < this.prizes.length; i++) {
						var angle = this.startAngle + i * arc
						ctx.fillStyle = i % 2 ? '#fff4fa' : '#fff'
						ctx.beginPath()
						//  arc(x,y,r,起始角,结束角,绘制方向) 方法创建弧/曲线（用于创建圆或部分圆）
						ctx.arc(211, 211, this.outsideRadius, angle, angle + arc, false)
						ctx.arc(211, 211, this.insideRadius, angle + arc, angle, true)
						ctx.fill()
						// 锁画布(为了保存之前的画布状态)
						ctx.save()
						// ----绘制奖品开始----
						// translate方法重新映射画布上的 (0,0) 位置
						ctx.translate(211 + Math.cos(angle + arc / 2) * this.textRadius, 211 + Math.sin(angle + arc / 2) * this.textRadius)
						let img = new Image()
						img.src = this.prizes[i].url ? this.prizes[i].url : '';
						ctx.drawImage( img,-50,-50,98,98 )
						// rotate方法旋转当前的绘图
						ctx.rotate(angle + arc / 2 + Math.PI / 2)
						// 把当前画布返回（调整）到上一个save()状态之前
						ctx.restore()
						// 绘制奖品结束
					}
				}
			},
		}
	}
</script>

<style scoped="scoped">
	main#lucky {
		width: 100%;
		background: url(../../../static/images/bg.jpg) no-repeat;
		background-size: cover;
	}
	.zpwrap{
		margin-top: 40px;
		position: relative;
	}	
	.lucky_box{
		position: relative;
		overflow: hidden;
		z-index: 1;
	}
	.luckyTop {
		transition: all 0.5s;
		margin-top: -36px;
	}
	.lucky-rule {
		position: absolute;
		top: 1.2rem;
		right: 0;
		font-size: 13px;
		color: #fff;
		background: rgba(70, 61, 72, 0.4);
		padding: 5px 8px;
		border-radius: 20px 0 0 20px;
	}
	
	.lucky-title {
		padding-top: 1rem;
		text-align: center;
	}
	
	.lucky-title > img {
		width: 70%;
	}
	.lucky-title > p {
		color:#fff;
		margin-top: -15px;
	}
	.lucky-sdate {
		display: inline-block;
		transform:rotate(6.2rad);
	}
	.lucky-edate {
		display: inline-block;
		transform:rotate(0.08rad);
	}
	.lucky-turnplate {
		position:relative;
		text-align: center;
		background: url(../../../static/images/gif.gif) no-repeat center;
		background-size: 98%;
		/*margin-top: -10px;*/
	}
	
	.lucky-turnplate canvas.item {
		/*margin-top: 10px;*/
		width: 96%;
	}
	
	.lucky-turnplate img.pointer {
		position: absolute;
		width: 20%;
		left: 40%;
		top: 33%;
	}
	.lucky-turnplate p {
		position: absolute;
		top: 45%;
		left: 45%;
		font-size: 1.8em;
		font-weight: bolder;
		color: #fff;
		letter-spacing:3px;
	}
	.lucky-winners {
		display: block;
		position: relative;
		margin-top: 0.6rem;
		text-align: center;
		width:80%;
		background: url(../../../static/images/winner.png) no-repeat;
		margin: 10px auto;
		background-size:100%;
		padding-top:5%;
		height:36px;
		overflow: hidden;
	}
	
	.lucky-winners > img {
		width: 75%;
	}
	.lucky-winners li {
		width:100%;
		line-height:36px; 
		font-size: 12px;
		color:#4a0b0b;
	}
	.lucky-myprize {
		text-align: center;
	}
	
	.lucky-myprize>img {
		width: 45%;
		padding-top: 12px;
	}
	
	.lucky-QRcode {
		margin-top: 2rem;
		text-align: center;
		padding-bottom: 2rem;
	}
	
	.lucky-QRcode>img {
		width: 42%;
		margin-bottom: 0.2rem;
	}
	
	.lucky-QRcode>p {
		padding: 0.1rem;
		font-size: 14px;
		color: #fff;
		font-weight: 100;
	}
	aside {
		box-sizing:content-box;
		overflow:hidden;
		z-index:2;
		position:fixed;
		top:0;
		left:0;
		background: rgba(122,122,122,0.5);
		width:100%;
		height:100%;
	}
	aside > div {
		z-index: 3;
		background: #ff3c53;
		border-radius: 12px;
		position: relative;
	}
	aside > div.lucky-prompt {
		background: #ff3c53;
		width:70%;
		margin: 40% auto;
		padding-top:5%;
		padding-bottom: 5%;
	}
	.lucky-prompt > p {
		color: #fff;
		/*font-size: 18px;*/
		font-size: 17px;
		letter-spacing: 1px;
		/*padding-top:8%;*/
		text-align: center;
		/*padding: 2%;*/
		margin: 2%;
		white-space:nowrap;
		overflow: hidden;
	}
	.lucky-imgtitle {
		text-align: center;
	}
	.lucky-imgtitle > img {
		z-index: 5;
		width:80%;
		margin:0 auto;
	}
	.lucky-imgtitle span> img {
		z-index: 5;
		width:80%;
		margin:0 auto;
	}
	.lucky-imgtitle span{
		/*display: block;
		position: relative;*/
	}
	.lucky-prompt > p.lucky-hint {
		font-size: 13px;
		margin-top: -6%;		
		margin-bottom: 6%;
	}
	.lucky-prompt a {
		display: block;
		border-radius: 5px;
		background: #eefd48;
		color:#ff1425;
		text-align: center;
		/*font-size:18px;*/
		font-size:17px;
		width:70%;
		padding:6px;
		margin: 0 auto;
	}
	.lucky-prompt-close {
		position:absolute;
		top:-40px;
		right:0px;
	}
	.lucky-prompt-close > img {
		width:32px;
	}
	.lucky-rule-page {
		background: #fff;
		margin: 30% auto;
		width:80%;
		padding-bottom: 5%;
	}
	.lucky-rule-page > .lucky-rule-title {
		padding-top: 15px ;
		text-align: center;
	}
	.lucky-rule-page > .lucky-rule-title > img{
		width:45%;	
	}
	.lucky-rule-list {
		margin: 12px;
		line-height: 20px;
	}
	.lucky-rule-list > p {
		font-size: 12px;
		color: #4A0B0B;
		margin: 2px;
		padding:2px;
	}
	.ticketvalwrap{
		/*display: block;
		position: relative;*/
	}
	#ticketval{
		position: absolute;
		top: 32%;
		left: 38%;
		color: #ff1425;
		font-size: 5em;
	}
	#pallsale{
		padding-top:0 ;
		font-size: 17px;
	}
	#litticval{
		font-size: 18px;
	}
	#valwrap{
		/*display: block;
		position: relative;*/
	}
	#litticval1{
		font-size: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/views/Ticket/lucky.vue